import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Home, FileText, Receipt, LogOut, Sparkles, User, CalendarPlus } from "lucide-react";
import { portalLogout, getPortalClient, isPortalAuthenticated } from "../../lib/portalApi";
import { useI18n } from "../../i18n/I18nContext";
import { LanguageToggle } from "../../components/LanguageToggle";

const navItems = [
  { to: "/portal", label: "Início", icon: Home, end: true },
  { to: "/portal/agendar", label: "Agendar", icon: CalendarPlus },
  { to: "/portal/agenda", label: "Minha Agenda", icon: FileText },
  { to: "/portal/recibos", label: "Recibos", icon: Receipt },
  { to: "/portal/orcamentos", label: "Orçamentos", icon: FileText },
];

export default function PortalLayout() {
  const nav = useNavigate();
  const client = getPortalClient();
  const { t } = useI18n();

  React.useEffect(() => {
    if (!isPortalAuthenticated()) nav("/portal/login", { replace: true });
  }, [nav]);

  function logout() {
    portalLogout();
    nav("/portal/login", { replace: true });
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Top bar (mobile + desktop) */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-20" data-testid="portal-header">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center">
              <Sparkles size={18} />
            </div>
            <div>
              <div className="text-sm font-semibold text-slate-900">{t("Portal Clean Manager USA")}</div>
              {client && (
                <div className="text-xs text-slate-500 flex items-center gap-1">
                  <User size={11} /> {client.name}
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <LanguageToggle compact testId="portal-language-toggle" />
            <button
              data-testid="portal-logout-btn"
              onClick={logout}
              className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-rose-600 transition-colors"
            >
              <LogOut size={15} /> <span className="hidden sm:inline">{t("Sair")}</span>
            </button>
          </div>
        </div>
        {/* Nav tabs */}
        <nav className="max-w-5xl mx-auto px-2 flex gap-1 overflow-x-auto border-t border-slate-100" data-testid="portal-nav">
          {navItems.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={`portal-nav-${it.to.replace(/[/]/g, "-").replace(/^-/, "")}`}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-3 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                    isActive
                      ? "border-blue-600 text-blue-700 font-semibold"
                      : "border-transparent text-slate-600 hover:text-slate-900"
                  }`
                }
              >
                <Icon size={15} />
                {t(it.label)}
              </NavLink>
            );
          })}
        </nav>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
